









import { Component, Vue, Watch } from "vue-property-decorator";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";

@Component
export default class CodingConfigBase extends BaseVue {
  created() {
  }
}
